<template>
    <b-card :class="`mb-0 ${cardClass}`">
        <b-form-group>
            <b-form-input
                size="sm"
                :value="title"
                :state="validations.title"
                :placeholder="$t('form.placeholder.title')"
                @input="onInputValue('title', $event)"
            />
        </b-form-group>
        <b-form-textarea
            trim
            size="sm"
            no-resize
            :value="description"
            :state="validations.description"
            :placeholder="$t('form.placeholder.description')"
            @input="onInputValue('description', $event)"
        />
    </b-card>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: '',
        },
        validations: {
            type: Object,
            required: true,
        },
    },
    computed: {
        cardClass() {
            const isValid =
                this.validations.title && this.validations.description
            return isValid ? 'quadrant_valid' : ''
        },
    },
    methods: {
        onInputValue(prop, value) {
            this.$emit('update', prop, value)
        },
    },
}
</script>
<style lang="sass" scoped>
.quadrant_valid
    border-color: #009BDB

textarea.form-control
    background-color: #EBF9FF
    height: 120px

.was-validated .form-control:valid, .form-control.is-valid, .form-control.is-valid:focus
    background-image: none !important
</style>
